import React from 'react';
import Cart from '../Cart/Cart';
import Checkout from './Checkout/Checkout';
import OrderConfirmation from './OrderConfirmation/OrderConfirmation';
import ProtectedRoute from '../../Component/ProtectedRoute';
import { dualStoreRoute } from '../../routes/dualStoreRoute';

const CartCheckoutRoutes = () => (
    <>
        {dualStoreRoute('/:lang/cart', <Cart />, 'cart')}
        {dualStoreRoute('/:lang/checkout/:userId', (
            <ProtectedRoute>
                <Checkout />
            </ProtectedRoute>
        ), 'checkout')}
        {dualStoreRoute('/:lang/order-confirmation', <OrderConfirmation />, 'order-confirmation')}
    </>
);

export default CartCheckoutRoutes;
